import httpClient from 'httpClient';

class NarrativeService {
  static createNarrative(celebrityId, narrative) {
    return httpClient.post(`/celebrities/${celebrityId}/narratives`, { narrative });
  }

  static updateNarrative(celebrityId, narrativeId, narrative) {
    return httpClient.put(`/celebrities/${celebrityId}/narratives/${narrativeId}`, { narrative });
  }

  static processNarrative(celebrityId, narrativeId) {
    return httpClient.post(`/celebrities/${celebrityId}/narratives/${narrativeId}/generate`, {});
  }

  static deleteNarrative(celebrityId, narrativeId) {
    return httpClient.delete(`/celebrities/${celebrityId}/narratives/${narrativeId}`);
  }

  static reportNarrative({ narrativeId, params }) {
    return httpClient.post(`/narratives/${narrativeId}/reported_contents`, params);
  }

  static getNarrativeById(narrativeId, celebrityId) {
    return httpClient.get(`/celebrities/${celebrityId}/narratives/${narrativeId}`);
  }

  static createMultipartUpload(title, mimeType) {
    return httpClient.post('/videos/upload_multipart_video', {
      title,
      mime_type: mimeType
    });
  }

  static getMultipartUploadUrl(uploadId, mediaId, partNumber) {
    return httpClient.get(`/videos/multipart_upload_url`, {
      params: {
        upload_id: uploadId,
        media_id: mediaId,
        part_number: partNumber
      }
    });
  }

  static completeMultipartUpload(uploadId, mediaId, parts) {
    return httpClient.post('/videos/complete_multipart_upload', {
      upload_id: uploadId,
      media_id: mediaId,
      parts
    });
  }
}

export default NarrativeService;
